(() => {
  const replacements = new Map([
    ['首页', 'Dao Origin'],
    ['首頁', 'Dao Origin'],
    ['目录', 'Shop'],
    ['目錄', 'Shop'],
    ['联系我们', 'Contact'],
    ['聯絡我們', 'Contact'],
    ['天然材质 · 东方意象 · 克制呈现', 'Daoist-inspired objects, selected for material and meaning.'],
    ['根植传统。面向当今。', 'Rooted in Tradition. Made for the Present.'],
    ['以道家智慧、天然材料和象征性仪式的宁静力量为灵感，匠心制作。', 'Daoist-inspired objects selected for material truth, symbolic clarity, and a quieter way to live with meaning.'],
    ['选购系列', 'Shop Objects'],
    ['道家文化最新礼记。', 'Latest Notes on Daoist Culture.'],
    ['道家礼记', 'Dao Notes'],
    ['关于道之本源中的符号、法器、材料和哲学的小短文。', 'Short essays on symbols, ritual objects, materials, and the philosophy behind Dao Origin.'],
    ['阅读所有礼记', 'Read all notes'],
    ['道家笔记、物品保养与静默抵达。', 'Dao Notes, material care, and quiet arrivals.'],
    ['关于礼器、天然材料和道源系列新作品的随笔。扎根、内敛，从不夸张。', 'Occasional notes on ritual objects, natural materials, and new Dao Origin pieces. Grounded, restrained, and never overstated.'],
    ['条款和政策', 'Terms & Policies'],
    ['條款及政策', 'Terms & Policies'],
    ['殷元帅“百无禁忌”道教护身铜符吊坠', 'Marshal Yin "No Taboos" Brass Amulet Pendant'],
    ['赵公明财富守护铜符吊坠', 'Zhao Gongming Wealth Guardian Brass Amulet Pendant'],
    ['宋璇', 'Dao Origin'],
    ['五月', 'May'],
  ]);

  const replaceText = (root = document.body) => {
    if (!root) return;
    const shouldSkip = (node) => {
      const parent = node.parentElement;
      return Boolean(parent?.closest?.('localization-form-component, drawer-localization-component, dropdown-localization-component, select, option, script, style'));
    };
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => shouldSkip(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT,
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      let value = node.nodeValue;
      replacements.forEach((replacement, source) => {
        value = value.replaceAll(source, replacement);
      });
      value = value.replace(/(\d{4})年(\d{1,2})月(\d{1,2})日/g, (_, year, month, day) => {
        const date = new Date(Number(year), Number(month) - 1, Number(day));
        return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
      });
      node.nodeValue = value;
    });
  };

  const run = () => {
    replaceText(document.querySelector('#header-group'));
    replaceText(document.querySelector('#MainContent'));
    replaceText(document.querySelector('footer'));
  };

  let scheduled = false;
  const scheduleRun = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  setTimeout(run, 800);
  setTimeout(run, 2000);
  ['#header-group', '#MainContent', 'footer'].forEach((selector) => {
    const target = document.querySelector(selector);
    if (target) new MutationObserver(scheduleRun).observe(target, { childList: true, subtree: true });
  });
})();

(() => {
  const main = document.querySelector('#MainContent:is([data-template="collection"], [data-template^="collection."])');
  if (!main) return;

  const path = window.location.pathname;
  const isAllProductsRoute =
    path === '/collections/all' ||
    path.startsWith('/collections/all/') ||
    path === '/collections/shop-objects-live' ||
    path.startsWith('/collections/shop-objects-live/') ||
    path === '/collections/shop-objects' ||
    path.startsWith('/collections/shop-objects/');
  if (!isAllProductsRoute) return;

  const collectionMap = {
    '/collections/all/daoist-pendants': {
      eyebrow: 'Daoist Pendants',
      title: 'Daoist Pendants',
      description:
        'Wearable Daoist-inspired objects selected for material presence, symbolic clarity, and restrained daily use.',
    },
    '/collections/shop-objects-live/daoist-pendants': {
      eyebrow: 'Daoist Pendants',
      title: 'Daoist Pendants',
      description:
        'Wearable Daoist-inspired objects selected for material presence, symbolic clarity, and restrained daily use.',
    },
    '/collections/all/body-tools': {
      eyebrow: 'Body Tools',
      title: 'Body Tools',
      description:
        'Care objects selected for quiet daily routines, clear use guidance, and a calm Dao Origin finish.',
    },
    '/collections/shop-objects-live/body-tools': {
      eyebrow: 'Body Tools',
      title: 'Body Tools',
      description:
        'Care objects selected for quiet daily routines, clear use guidance, and a calm Dao Origin finish.',
    },
  };

  const content = collectionMap[path] || {
    eyebrow: 'Shop Objects',
    title: 'Shop Objects',
    description:
      'A curated field of Daoist-inspired objects selected for material presence, symbolic clarity, and restrained daily use. Browse by material, form, and purpose without exaggerated promises.',
  };

  const assetBase = [...document.scripts]
    .map((script) => script.src)
    .find((src) => src.includes('dao-origin-responsive-fit.js'))
    ?.replace(/dao-origin-responsive-fit\.js.*$/, '');

  const loadSystemStyles = () => {
    if (!assetBase || document.querySelector('link[href*="dao-origin-store-system.css"]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${assetBase}dao-origin-store-system.css`;
    document.head.appendChild(link);
  };

  const setMeta = () => {
    document.title = `${content.title} | Dao Origin`;
    let description = document.querySelector('meta[name="description"]');
    if (!description) {
      description = document.createElement('meta');
      description.name = 'description';
      document.head.appendChild(description);
    }
    description.content = content.description;
  };

  const injectFallbackCss = () => {
    if (document.querySelector('#dao-shop-cache-fallback-css')) return;
    const style = document.createElement('style');
    style.id = 'dao-shop-cache-fallback-css';
    style.textContent = `
      html.dao-shop-polish #MainContent[data-template='collection'] {
        background: #030303;
        color: #f6f0e6;
      }

      html.dao-shop-polish #MainContent[data-template='collection'] > .section-wrapper[id*='__section'] {
        display: none !important;
      }

      html.dao-shop-polish #MainContent[data-template='collection'] .facets__filters-wrapper,
      html.dao-shop-polish #MainContent[data-template='collection'] .facets-drawer__filters,
      html.dao-shop-polish #MainContent[data-template='collection'] .facets--filters-title,
      html.dao-shop-polish #MainContent[data-template='collection'] .filter-remove-buttons {
        display: none !important;
      }

      html.dao-shop-polish #MainContent[data-template='collection'] .product-grid-container {
        padding-block: clamp(22px, 3vw, 42px) clamp(60px, 7vw, 110px) !important;
      }

      html.dao-shop-polish #MainContent[data-template='collection'] .product-card__content {
        border: 1px solid rgba(196, 154, 87, .16) !important;
        background: rgba(13, 11, 10, .78) !important;
        transition: transform 220ms ease, border-color 220ms ease, background 220ms ease;
      }

      html.dao-shop-polish #MainContent[data-template='collection'] product-card:hover .product-card__content {
        transform: translateY(-3px);
        border-color: rgba(196, 154, 87, .42) !important;
        background: rgba(3,3,3, .92) !important;
      }

      html.dao-shop-polish #MainContent[data-template='collection'] .card-gallery {
        aspect-ratio: 4 / 5;
        overflow: hidden;
        background: #030303 !important;
      }

      html.dao-shop-polish #MainContent[data-template='collection'] .card-gallery img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        filter: saturate(.92) contrast(1.04);
        transition: transform 360ms ease, filter 360ms ease;
      }

      html.dao-shop-polish #MainContent[data-template='collection'] product-card:hover .card-gallery img {
        transform: scale(1.025);
        filter: saturate(.98) contrast(1.06);
      }

      html.dao-shop-polish #MainContent[data-template='collection'] product-card p[role='heading'],
      html.dao-shop-polish #MainContent[data-template='collection'] product-card .product-grid__card a {
        color: #dfd4c2 !important;
        font-size: .94rem !important;
        line-height: 1.36 !important;
        letter-spacing: 0 !important;
      }

      html.dao-shop-polish #MainContent[data-template='collection'] product-price,
      html.dao-shop-polish #MainContent[data-template='collection'] .price,
      html.dao-shop-polish #MainContent[data-template='collection'] .price * {
        color: #c49a57 !important;
        font-size: .78rem !important;
        letter-spacing: .1em;
        text-transform: uppercase;
      }
    `;
    document.head.appendChild(style);
  };

  const navItems = [
    ['All objects', '/collections/all?view=shop-premium-1'],
    ['Lightning-Struck Wood', '/collections/lightning-struck-wood-1'],
    ['Copper & Brass', '/collections/copper'],
    ['Daoist Pendants', '/collections/all/daoist-pendants?view=shop-premium-1'],
    ['Incense', '/collections/incense'],
    ['Body Tools', '/collections/all/body-tools?view=shop-premium-1'],
  ];

  const injectHero = () => {
    if (main.querySelector('.dao-collection-hero')) return;
    const hero = document.createElement('section');
    hero.className = 'dao-collection-hero';
    hero.setAttribute('aria-label', 'Collection introduction');
    hero.innerHTML = `
      <div class="dao-collection-hero__inner">
        <div>
          <p class="dao-collection-hero__eyebrow">${content.eyebrow}</p>
          <h1>${content.title}</h1>
        </div>
        <p class="dao-collection-hero__copy">${content.description}</p>
      </div>
      <nav class="dao-collection-nav" aria-label="Shop collections">
        ${navItems
          .map(([label, href]) => {
            const itemPath = new URL(href, window.location.origin).pathname;
            const active =
              itemPath === path ||
              ((path === '/collections/all' || path === '/collections/shop-objects-live') &&
                itemPath === '/collections/all');
            return `<a href="${href}" ${active ? 'aria-current="page"' : ''}>${label}</a>`;
          })
          .join('')}
      </nav>
    `;
    main.prepend(hero);
  };

  const run = () => {
    document.documentElement.classList.add('dao-shop-polish');
    loadSystemStyles();
    injectFallbackCss();
    injectHero();
    setMeta();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  setTimeout(run, 800);
  setTimeout(run, 2000);
})();

(() => {
  const ORACLE_PATH = '/pages/zhenwu-oracle';
  const ORACLE_VIEW = 'zhenwu-oracle-stagefix-8';

  const normalizeOracleLinks = () => {
    document.querySelectorAll(`a[href*="${ORACLE_PATH}"]`).forEach((link) => {
      let url;
      try {
        url = new URL(link.getAttribute('href'), window.location.origin);
      } catch (_error) {
        return;
      }
      if (url.pathname !== ORACLE_PATH || url.searchParams.get('view') === ORACLE_VIEW) return;
      url.searchParams.set('view', ORACLE_VIEW);
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeOracleLinks, { once: true });
  } else {
    normalizeOracleLinks();
  }
  setTimeout(normalizeOracleLinks, 300);
  setTimeout(normalizeOracleLinks, 1200);
  setTimeout(normalizeOracleLinks, 2400);

  const observer = new MutationObserver(normalizeOracleLinks);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href'],
  });
})();

(() => {
  const main = document.querySelector('#MainContent:is([data-template="blog"], [data-template^="blog."])');
  if (!main) return;

  const normalizeBlogTitle = () => {
    const title = main.querySelector('h1');
    if (title && /最新消息/.test(title.textContent)) title.textContent = 'Dao Notes';
    if (/最新消息/.test(document.title)) document.title = 'Dao Notes | Dao Origin';
    let description = document.querySelector('meta[name="description"]');
    if (!description) {
      description = document.createElement('meta');
      description.name = 'description';
      document.head.appendChild(description);
    }
    description.content =
      'Short Dao Origin essays on Daoist culture, symbolic objects, natural materials, care, ritual atmosphere, and restrained daily meaning.';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeBlogTitle, { once: true });
  } else {
    normalizeBlogTitle();
  }
  setTimeout(normalizeBlogTitle, 800);
})();
